import axios from "../axios/index.js";

const urlGetProductList = "/api/product/get-list-customer";
const urlGetProductWithAll = "/api/product/get-product-with-all";
const urlGetProductDetail = "/api/product/product-detail/";
const urlGetCartList = "/api/product/get-product-by-ids";
const urlGetCartListByRoomType = "/api/product/get-product-by-room_type";
const urlGetProductrecentlyViewById = "/api/product/get-product-recently-view-by-ids";
const urlAddMyWishlist = "/api/product/add-my-wishlist";
const urlgetListMyWishlist = "/api/product/get-list-my-wishlist";
const urlDeleteWishlist = "/api/product/delete-my-wishlist/";

export default {
    getListCustomer(params) {
        return axios.post(urlGetProductList, params);
    },

    getProductWithAll(params) {
        return axios.post(urlGetProductWithAll, params);
    },

    getProductDetail(slug) {
        return axios.post(urlGetProductDetail + slug);
    },

    getProductByIds(params) {
        return axios.post(urlGetCartList, params);
    },

    addMyWishlist(params) {
        return axios.post(urlAddMyWishlist, params);
    },

    getListMyWishlist(params) {
        return axios.post(urlgetListMyWishlist, params);
    },

    deleteWishlist(id) {
        return axios.post(urlDeleteWishlist + id, id);
    }
};

